<template>
  <div class="">
    <el-form>
    <el-form-item label="用户购买数据" required>
            <el-upload
              action=""
              :on-change="beforeUpload"
              :file-list="fileList"
              :auto-upload="false"
              :show-file-list="true"
              accept=".xls, .xlsx"
              list-type="text"
              :limit="1"
              ref="upload"
            >
              <el-button type="success" size="small">导入表格</el-button>
              <el-button
                type="text"
                @click.stop="loadTemplate"
                style="margin: 10px"
                >下载模板</el-button
              >
            </el-upload>
          </el-form-item>
</el-form>

    <el-button size="small" type="primary" @click="importMemberExcel"
      >提交</el-button
    >

   
  </div>
</template>

<script>
import XLSX from "xlsx";
export default {
  props: {
    cooperator: {
      type: Object,
      default: () => {
        return {};
      },
    },
    cooperator_id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      type: {
        cooperator: "合作商",
        property: "物业",
        commerce: "商会",
      },
      DataList: [],
      Option: [
        { name: "发卡方", value: "channels" },
        { name: "发卡类型", value: "coupon_type" },
        { name: "说明", value: "descr" },
        { name: "用户", value: "user", type: "custom" },
        { name: "发卡时间", value: "create_time" },
      ],
      Total: 0,
      sendShow: false,
      community_id: "",
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      fileData: "",
      send_type: "mobiles",
      loading: false,
      fileList: [],
      descr: "",
      memberList: [],
      change_mamber: "",
    };
  },

  mounted() {
    
  },

  methods: {
    loadTemplate() {
      let Header = [["课程id", "时间"]];
      let exportArr = [
        ["2478", "2025-01-01 12:00:00"],
      ];

      const headerWs = XLSX.utils.aoa_to_sheet(Header);
      const ws = XLSX.utils.sheet_add_json(headerWs, exportArr, {
        skipHeader: true,
        origin: "A2",
      });
      ws["!cols"] = [
        {
          wpx: 100,
        },
        {
          wpx: 100,
        }
      ];
      /* 新建空的工作表 */
      const wb = XLSX.utils.book_new();

      // 可以自定义下载之后的sheetname
      XLSX.utils.book_append_sheet(wb, ws, "sheetName");

      /* 生成xlsx文件 */
      XLSX.writeFile(wb, "购买数据模板.xlsx");
      this.$message("导出成功，请前往下载列表查看");
    },
    upLoad(file) {
      console.log(file);
    },

    importMemberExcel() {
      if (!this.fileData) {
        this.$message("请选择要导入的数据");
        return;
      }
      let formDate = new FormData();
      formDate.append("file", this.fileData);
      formDate.append("mechanism_id", this.$route.query.mecID)
      this.loading = true;
      this.$axios({
        url: "/user/stat/batchBuy",
        data: formDate,
        method: "post",
        processData: false,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((res) => {
          this.getList(1);
          this.$message({ message: res.data.data });
          this.sendShow = false;
          this.loading = false;
          this.fileList = [];
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 文件选择回调
    beforeUpload(file) {
      this.fileData = file.raw;
      this.readExcel(); // 调用读取数据的方法
    },
    // 读取数据
    readExcel(e) {
      const files = this.fileData;

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
          console.log(ws);
        } catch (e) {
          return false;
        }
      };
    },
  },
};
</script>

<style lang="less" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
a:hover {
  color: #333;
}

.table {
  height: 30px;
  line-height: 30px;
  border: 1px solid #333;
  border-bottom: none;
  padding: 0 10px 0 2px;
}
</style>